import styled from "styled-components"

export const StyledWrapper = styled.div`
  @media only screen and (min-width: 636px) {
    margin: 0 auto;
    width: 540px;
  }
`
